import { createAction, EmptyActionCreator } from 'redux-act';

const MODULE_ID = 'FD_USER_';

const createUserAction = <T>(type: string) =>
  createAction<T>(`${MODULE_ID}${type}`);

export const setName = createUserAction<{ name: string }>('SET_NAME');

// #region just events

/** (TEMPORARY) one way bridge from old actions and new sagas world */
export const loginRequestBridge = createUserAction(
  'LOGIN_REQUEST_BRIDGE',
) as EmptyActionCreator;
export const loginSuccessBridge = createUserAction(
  'LOGIN_SUCCESS_BRIDGE',
) as EmptyActionCreator;
export const loginErrorBridge = createUserAction(
  'LOGIN_ERROR_BRIDGE',
) as EmptyActionCreator;

export const logoutSuccessBridge = createUserAction(
  'LOGOUT_SUCCESS_BRIDGE',
) as EmptyActionCreator;
// #endregion
